module.exports = __webpack_public_path__ + "static/fonts/Fact-SemiExpandedLight.8c94e6b.ttf";